import axios from "axios";

const url = "https://scuffedwebsite.com/mal/api/posts";
export const fetchPosts = async () => await axios.get(url);
export const createPost = async (post_data) => await axios.post(url, post_data);
export const updatePost = async (id, post_data) => await axios.patch(`${url}/${id}`, post_data);
export const deletePost = async (id) => await axios.delete(`${url}/${id}`);